
class HXFormFieldMultiUploadBig extends HXFormField {

    MAX_UPLOAD_FILE_UNLIMITED = 0;
    MAX_UPLOAD_SIZE_UNLIMITED = 0;

    constructor(inputName,formName) {
        super(inputName,formName);
    }

    /**
     * @returns {boolean}
     */
    validateInput(alertResult=true) {
        super._validateFieldInit();

        if (this.fieldExists()===true && this.getEditable() === true) {

            if (!this.getOptional()) {
                if(this.getFileCountTotal() === 0) {
                    this.validationMsg = hx.replace(this.formVars.dictUploadBigOptionalMsg, "#name#", this.getLabel());
                    this.validationPassed = false;
                }
            }

            if (this.getUploadFileCountMax() !== this.MAX_UPLOAD_FILE_UNLIMITED) {
                if(this.getFileCountTotal() > this.getUploadFileCountMax()) {
                    this.validationMsg = hx.replace(this.formVars.dictUploadBigZuVieleUploads, "#name#", this.getLabel());
                    this.validationMsg = hx.replace(this.validationMsg, "#max#", this.getUploadFileCountMax());
                    this.validationPassed = false;
                }
            }

            if (this.getUploadTotalSizeMax() !== this.MAX_UPLOAD_SIZE_UNLIMITED) {
                if(this.getFileSizeTotal() > this.getUploadTotalSizeMax()) {
                    this.validationMsg = hx.replace(this.formVars.dictUploadBigFileSize, "#name#", this.getLabel());
                    this.validationMsg = hx.replace(this.validationMsg, "#max#", hx.formatByteSize(this.getUploadTotalSizeMax()));
                    this.validationPassed = false;
                }
            }

            if (this.getUploadFileExtAllowed() !== "") {
               var fileExtensionIsValid = true;
               var extArr = hx.explode(",",this.getUploadFileExtAllowed());

               $(this.inputObj).find('.js-new-files .js-li').each((key, obj) => {
                   var filename = $(obj).attr('data-filename');

                   var thisFileExtensionsIsValid = false;
                   $(extArr).each((key, value) => {
                       if(!thisFileExtensionsIsValid && hx.endsWith(filename.toLowerCase(), value.trim())) {
                           thisFileExtensionsIsValid = true;
                           return false; //break loop
                       }
                   });
                   if(!thisFileExtensionsIsValid) {
                       fileExtensionIsValid = false;
                       return false; //break loop
                   }
               });

               if(!fileExtensionIsValid) {
                   this.validationMsg = hx.replace(this.formVars.dictUploadBigFileExtension, "#name#", this.getLabel());
                   this.validationMsg = hx.replace(this.validationMsg, "#formate#", this.getUploadFileExtAllowed());
                   this.validationPassed = false;
               }
            }


            if (alertResult===true) super._validateFieldAlert();

        }
        return this.validationPassed;
    }

    /**
     * Neue Uploaddatei hinzufuegen
     * @param {object} fileData
     */
    addFile(fileData) {
        var pos = this.getFileCountNew() + 1;

        //wenn maxupload = 1 und schon ein file vorhanden, dann zum loeschen markieren
        if (this.getUploadFileCountMax() === 1) {
            var deleteBtn = $(this.inputObj).find(".js-existing-files li").first().find(".js-delete");
            if (hx.cint(deleteBtn.attr("data-del")) === 0) deleteBtn.trigger("click");
        }

        var size = fileData.files[0].size;
        var filename = fileData.files[0].name;
        var filenameWithSize = filename + " (" + hx.formatByteSize(size, 1) + ")";

        var tpl = $('<li class="js-li upload" data-pos="' + pos + '" data-filename="'+filename+'" data-filesize="' + size + '">' +
                        '<div class="file-icon"><span class="hx-fa-icon-container hx-fa-icon"><i class="fa-regular fa-file-circle-plus"></i></span></div>' +
                        '<div class="filename js-filename" title="' + filenameWithSize + '">' + filenameWithSize + '</div>' +
                        '<div class="delete js-delete"><span class="hx-fa-icon-container hx-fa-icon-on"><i class="fa-solid fa-xmark"></i></span></div>' +
                        '<input type="hidden" name="start-upload">' +
                        '<input type="hidden" name="' + this.getTokenValue() + '_' + pos + '" value="' + filename + '">' +
                        '</li>');

        //Daten fuer Ajax hinzufuegen
        fileData.formData = {token: this.getTokenValue(), pos: pos};

        //Neues Uploadfile in die Liste einfuegen
        var $newFileList = $(this.inputObj).find(".js-new-files");
        fileData.context = tpl.appendTo($newFileList);

        //Filename kuerzen
        var text = this.getFileNameShortened(tpl.find(".js-filename").attr("title"));
        tpl.find(".js-filename").html(text);

        //Uploadinfo aktualisieren (Anzahl und Gesamtgroesse)
        this.setDropZoneText(pos, this.getFileSizeNew());

        // Listen for clicks on the remove icon
        tpl.find(".js-delete").on("click", () => {
            tpl.fadeOut(() => {
                tpl.remove();
                this.setDropZoneText(this.getFileCountNew(), this.getFileSizeNew());
                this.inputObj.dispatchEvent(new Event('change'));
            });
        });

        tpl.find("[name=\"start-upload\"]").on("startupload", function () {
            fileData.submit();
        });

        // Objektreferenz auf das File-Objekt als Data-Attribut merken (wird f�r getAddedFilesArray() gebraucht)
        tpl.find("[name=\"start-upload\"]").data("fileobject",fileData.files[0]);
    }


    /**
     * returns an array of filenames for all new files
     * @returns array of file-objects
     */
    getFileNameArrayNew (){
        var arr=[];
        $(this.inputObj).find("[name=\"start-upload\"]").each(function (index){
            arr[arr.length] = $(this).data("fileobject").name;
        });
        return arr;
    }

    /**
     * liefert den Inhalt des Files
     * @param {string} filename
     * @param {function} contentCallbackFunction (anonyme function mit Parametern: content, filename)
     * @returns {boolean} erfolgreich=true
     */
    getFileContentNew (filename,contentCallbackFunction) {
        var arr=[];
        var file = null;
        // File suchen
        $(this.inputObj).find("[name=\"start-upload\"]").each(function (index){
            if (filename == $(this).data("fileobject").name){
                file=$(this).data("fileobject");
            }
        });
        if (file===null) return false;  // Filename nicht gefunden
        // Reader einbinden:
        let reader = new FileReader();
        reader.onload = function(e){
            const content = e.target.result;
            contentCallbackFunction (content,filename);
        };
        reader.onerror = function(e){
            // im Fehlerfall: leerer Callback-Aufruf
            contentCallbackFunction ('',filename);
        };
        reader.readAsText(file);
    }


    /**
     * @param {boolean} optional
     */
    setOptional(optional) {
        super.setOptional(optional,'uploadbig');
    }

    /**
     * @param {int} anzNeueDateien
     * @param {int} gesamtGroesseBytes
     */
    setDropZoneText(anzNeueDateien, gesamtGroesseBytes) {
        var dictText = this.formVars.dictUploadBigAnzNeueDateien;
        dictText = hx.replace(dictText, "#anzahl#", hx.cint(anzNeueDateien));
        dictText = hx.replace(dictText, "#totalsize#", hx.formatByteSize(hx.cint(gesamtGroesseBytes), 1));
        $(this.inputObj).find(".upload-info").html(dictText);
    }

    /**
     * Liefert Anzahl der Dateien (neu und bereits hochgeladen)
     * @return {number}
     */
    getFileCountTotal() {
        var count = 0;
        count += this.getFileCountExisting();
        count += this.getFileCountNew();
        return count;
    }

    /**
     * Liefert Anzahl bereits hochgeladener Dateien - ohne die, die zum Loeschen markiert sind
     * @return {number}
     */
    getFileCountExisting() {
        return hx.cint($(this.inputObj).find(".js-existing-files").find(".js-li[data-del=0]").length);
    }

    /**
     * Liefert Anzahl der neu hinzugefuegten Dateien
     * @return {number}
     */
    getFileCountNew() {
        return hx.cint($(this.inputObj).find(".js-new-files").find(".js-li").length);
    }

    /**
     * Alle neu hinzugefuegten Datein entfernen
     */
    removeFileAllNew() {
        $(this.inputObj).find(".js-delete").trigger("click");
    }

    /**
     * Liefert die zum Loeschen markierte Dateianzahl
     * @return {int}
     */
    getFileCountDelete() {
        return hx.cint(this.getFileDeleteIds().length);
    }

    /**
     * Liefert Gesamtgroesse in Bytes der Dateien (neu und bereits hochgeladen)
     * @return {number}
     */
    getFileSizeTotal() {
        var size = 0;
        size += this.getFileSizeExisting();
        size += this.getFileSizeNew();
        return size;
    }

    /**
     * Liefert Gesamtgroesse in Bytes der neu hinzugefuegten Dateien
     * @return {number}
     */
    getFileSizeNew() {
        var totalSize = 0;
        $(this.inputObj).find(".js-new-files .js-li").each((key, obj) => {
            totalSize += hx.cint($(obj).attr("data-filesize"));
        });
        return totalSize;
    }

    /**
     * Liefert Gesamtgroesse in Bytes der existierenden Dateien - ohne die, die zum Loeschen markiert sind
     * @return {number}
     */
    getFileSizeExisting() {
        var totalSize = 0;
        $(this.inputObj).find(".js-existing-files").find(".js-li[data-del=0]").each((key, obj) => {
            totalSize += hx.cint($(obj).attr("data-filesize"));
        });
        return totalSize;
    }

    /**
     * Liefert Gesamtgroesse in Bytes der zum Loeschen markierten Dateien
     * @return {number}
     */
    getFileSizeDelete() {
        var totalSize = 0;
        $(this.inputObj).find(".js-existing-files").find(".js-li[data-del=1]").each((key, obj) => {
            totalSize += hx.cint($(obj).attr("data-filesize"));
        });
        return totalSize;
    }

    /**
     * Liefert die zum Loeschen markierten Datei-Ids
     * @return {array}
     */
    getFileDeleteIds() {
        var deleteIdsArray = hx.explode(',', $(this.inputObj).find("input[name='del" + this.getTokenName() + "']").val());
        deleteIdsArray = deleteIdsArray.filter(function (n) { return n !== undefined && n !== '';});
        return deleteIdsArray;
    }


    /**
     * Liefert Hoehe des Preview Img in Pixel
     * @return {number}
     */
    getFileImgPreviewHeight() {
        return hx.cint(this.inputObj.getAttribute("data-hx-file-img-preview-height"));
    }

    /**
     * Liefert Breite des Preview Img in Pixel
     * @return {number}
     */
    getFileImgPreviewWidth() {
        return hx.cint(this.inputObj.getAttribute("data-hx-file-img-preview-width"));
    }

    /**
     * @return {number}
     */
    getTokenName() {
        return this.inputObj.getAttribute("data-hx-token-name");
    }

    /**
     * @return {string}
     */
    getTokenValue() {
        return this.inputObj.getAttribute("data-token");
    }

    /**
     * @return {string} comma separated
     */
    getUploadFileExtAllowed() {
        return this.inputObj.getAttribute("data-hx-allowed-ext");
    }

    /**
     * @param {string} commaseparatedExt
     */
    setUploadFileExtAllowed(commaseparatedExt) {
        return this.inputObj.setAttribute("data-hx-allowed-ext",commaseparatedExt);
    }



    /** Maximal Anzahl Dateien - 0 = unlimited
     * @return
     */
    getUploadFileCountMax() {
        return hx.cint(this.inputObj.getAttribute("data-hx-max-upload-filecount"));
    }


    /**
     * Maximal Anzahl Dateien - 0 = unlimited
     * @param {int} count
     */
    setUploadFileCountMax(count) {
        this.inputObj.setAttribute("data-hx-max-upload-filecount",hx.cint(count));
    }

    /** Byte maximal aller Dateien (1024 = 1kByte), 0=unlimited
     * @return
     */
    getUploadTotalSizeMax() {
        return hx.cint(this.inputObj.getAttribute("data-hx-max-upload-size"));
    }

    /**
     * Byte maximal aller Dateien - 0 = unlimited
     * @param {int} sizeInBytes
     */
    setUploadTotalSizeMax(sizeInBytes) {
        this.inputObj.setAttribute("data-hx-max-upload-size",hx.cint(sizeInBytes));
    }

    /**
     * Angezeigten Dateinamen bei bedarf kuerzen
     * @param {string} text
     */
    getFileNameShortened(text) {
        var width = $(this.inputObj).width() - 100;
        return hx.guiSetEllipsis(text, width, 'center', 'classname')
    }


    /**
     * Events einhaengen
     */
    displayInit() {
        if (this.fieldExists()===true) {

            //File API check
            var fileApiSupported = !!('File' in window && 'FileReader' in window && 'FileList' in window && 'Blob' in window);
            if (!fileApiSupported) {
                this.inputObj.addClass('disabled');
                //upload icon ausblenden
                this.inputObj.find('.js-upload').hide();
                //error text anzeigen
                var text = this.formVars.dictUploadBigBrowserOld;
                this.inputObj.find('.upload-info').html(text).attr('title', text).addClass('error');
            }

            //Existierende Dateinamen kuerzen wenn noetig
            $(this.inputObj).find('.js-existing-files .js-filename a').each((key, obj) => {
                var text = this.getFileNameShortened($(obj).attr("title"));
                $(obj).html(text);
            });

            //Filedialog oeffnen steuern
            $(this.inputObj).find('.js-upload,.upload-info').on('click', () => {
                if ($(this.inputObj).hasClass('disabled')) return;
                $(this.inputObj).find('[type=\"file\"]').trigger('click');
            });

            // Einfaehrung der Dop-Zone wenn dragover
            $(this.inputObj).find(".js-drop-zone, .upload-info, .upload-field-info").on("dragover mouseover", (event) => {
                $(this.inputObj).find(".js-drop-zone").addClass("focus");
            }).on("dragleave mouseleave", (event) => {
                $(this.inputObj).find(".js-drop-zone").removeClass("focus");
            });

            //File loeschen button
            $(this.inputObj).find('.js-delete').on('click', (event) => {
                var delObject = $(this.inputObj).find("[name='del" + this.getTokenName() + "']");
                var deleteIds = delObject.val();
                var idToDelete = hx.cint($(event.currentTarget).data('id'));
                var deleteIdsArray = hx.explode(',', deleteIds);
                var dataDel = hx.cint($(event.currentTarget).parent().attr('data-del'));
                deleteIdsArray = deleteIdsArray.filter((n) => {
                    return (n !== undefined && n !== '');
                });
                if (dataDel === 1) {
                    deleteIdsArray = deleteIdsArray.filter((n) => {
                        return (hx.cint(n) !== idToDelete);
                    });

                    delObject.val(hx.implode(',', deleteIdsArray));
                    $(event.currentTarget).parent().attr('data-del', 0);

                    //normalen delete button anzeigen
                    $(event.currentTarget).find('i').css("color", "");
                } else {
                    deleteIdsArray.push(idToDelete);
                    delObject.val(hx.implode(',', deleteIdsArray));
                    $(event.currentTarget).parent().attr('data-del', 1);

                    //roten delete button anzeigen
                    $(event.currentTarget).find('i').css("color", "red");
                }
                this.inputObj.dispatchEvent(new Event('change'));
            });

            //Preview Image einblenden bzw. ausblenden
            $(".hx-formfield-multiupload[data-fieldname='" + this.inputName + "'] .js-preview").on('mouseover', (event) => {
                var imgcss = {
                    display: 'block',
                    position: 'absolute',
                    maxWidth: this.getFileImgPreviewWidth(),
                    maxHeight: this.getFileImgPreviewHeight(),
                    top: $(event.currentTarget).offset().top,
                    left: ($(event.currentTarget).offset().left + 20)
                };

                var img = $('<img class=\"hx-quick-preview\" src=\"' + event.currentTarget.getAttribute('data-previewlink') + '\">').css(imgcss);

                $('body').append(img);
            }).on('mouseout', function () {
                $('.hx-quick-preview').remove();
            });

            //Folder oeffnen bzw. schliessen
            $(".js-libhx_form_multiupload_big_toggler[data-fieldname='" + this.inputName + "']").on("click", (event) => {
                var $upload = $(".js-libhx_form_multiupload_big_toggler_upload[data-fieldname='" + this.inputName + "']");
                $upload.toggle();

                var $icon = $(".libhx_form_multiupload_big_toggler_icon[data-fieldname='" + this.inputName + "']").find("i");
                if ($upload.is(":visible")) {
                    $(this.inputObj).find(".js-existing-files .js-filename a,.js-new-files .js-filename").each((key, obj) => {
                        var text = this.getFileNameShortened($(obj).attr("title"));
                        $(obj).html(text);
                    });

                    $icon.removeClass("fa-solid fa-folder").addClass("fa-regular fa-folder-open");
                } else {
                    $icon.removeClass("fa-regular fa-folder-open").addClass("fa-solid fa-folder");

                }
            });

            //Suche im Suchfeld
            if (this.getEditable()) {
                var multiuploadSearchfieldTimeout = 0;
                $(".js-hx-formfield-multiupload_searchfield[data-fieldname='" + this.inputName + "']").on("keyup", (event) => {
                    if (event.key === "Tab") return;
                    var $searchField = $(event.target);
                    var $upload = $(".hx-formfield-multiupload[data-fieldname='" + this.inputName + "']");

                    if (multiuploadSearchfieldTimeout !== 0) clearTimeout(multiuploadSearchfieldTimeout);
                    multiuploadSearchfieldTimeout = setTimeout(() => {
                        $searchField.attr('disabled', true);
                        var search = $searchField.val().toLowerCase();
                        $upload.find(".js-li").show();
                        if (search !== "") {
                            $upload.find(".js-filename").each((key, obj) => {
                                if ($(obj).text().toLowerCase().indexOf(search) === -1) $(obj).parents(".js-li").hide();
                            });
                        }
                        $searchField.attr('disabled', false);
                        $searchField.trigger('focus');
                    }, 400);
                });
            }
        }
    }
}